import { add, length, map, reduce, values } from "ramda";

const CONTENT_TYPE_LABELS = {
  ALBUM: "Album",
  ARTICLE: "Article",
  AUDIO: "Audio",
  AUDIOBOOK: "Audiobook",
  BOOK: "Book",
  CHAPTER: "Chapter",
  DISSERTATION: "Dissertation",
  IMAGE: "Image",
  OTHER_DOCUMENT: "Document",
  VIDEO: "Video",
};

export const contentTypeCodes = [
  "ALBUM",
  "ARTICLE",
  "AUDIO",
  "AUDIOBOOK",
  "BOOK",
  "CHAPTER",
  "DISSERTATION",
  "IMAGE",
  "OTHER_DOCUMENT",
  "VIDEO",
];

export const getContentTypeLabel = type => CONTENT_TYPE_LABELS[type] || "Other";

export const contentTypeTerms = {
  terms: map(
    ct => ({ label: getContentTypeLabel(ct), queryParam: ct }),
    contentTypeCodes,
  ),
};

export const getTotalSelectedTerms = selected =>
  reduce(add, 0, values(map(f => length(f.terms), selected)));

/**
 * PROCESSING
 */
const CONTENT_PROCESSING_STATUS_LABELS = {
  PENDING: "Pending",
  PROCESSING: "Processing",
  FAILURE: "Failed",
};

export const contentProcessingStatuses = ["PENDING", "PROCESSING", "FAILURE"];

export const getContentProcessingStatusLabel = status =>
  CONTENT_PROCESSING_STATUS_LABELS[status];

export const contentProcessingStatusTerms = {
  terms: map(
    status => ({
      label: getContentProcessingStatusLabel(status),
      queryParam: status,
    }),
    contentProcessingStatuses,
  ),
};
